<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="rc_type"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.rc_type || "申请类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.rc_type"
              @change="onRctypeChange"
              placeholder="请选择"
            >
              <option>个人</option>
              <option>组织</option>
            </select>
          </div>
        </div>
        <department-field
          slot="rc_department"
          v-if="form.main.rc_type == '组织'"
          v-model="form.main.rc_department"
          @select="onSelectDepartment"
        />
        <datetime-field slot="rc_apply_start" :label="customLabel.rc_apply_start || '补班时间（起）'" v-model="form.main.rc_apply_start" />
        <datetime-field slot="rc_apply_end" :label="customLabel.rc_apply_end || '补班时间（止）'" v-model="form.main.rc_apply_end" />
        <datetime-field slot="rc_work_start" :label="customLabel.rc_work_start || '上班时间（起）'" v-model="form.main.rc_work_start" />
        <datetime-field slot="rc_work_end" :label="customLabel.rc_work_end || '上班时间（止）'" v-model="form.main.rc_work_end" />
        <div class="weui-cell" slot="rc_apply_count">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.rc_apply_count || "补班时长"
            }}</label>
          </div>
          <div class="weui-cell__bd flex">
            <input
              class="weui-input"
              type="number"
              disabled
              :value="form.main.rc_apply_count"
              placeholder="0"
            />
            <span>h</span>
          </div>
        </div>
        <div class="weui-cell" slot="rc_work_count">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.rc_work_count || "实际上班时长"
            }}</label>
          </div>
          <div class="weui-cell__bd flex">
            <input
              class="weui-input"
              type="number"
              disabled
              :value="form.main.rc_work_count"
              placeholder="0"
            />
            <span>h</span>
          </div>
        </div>
        <div class="weui-cell" slot="rc_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.rc_remark || "补班理由"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.rc_remark"
              placeholder="请输入"
            />
          </div>
        </div>
      </custom-layout>

      <div v-if="form.main.rc_type == '组织'">
        <div class="weui-cells__group" v-for="(item, xindex) in form.items" :key="xindex">
          <div class="weui-cells__title">
            <span>人员{{xindex+1}}</span>
            <a href="javascript:;" class="header-tool" @click="removeItem(xindex)">
              <span>删除</span>
            </a>
          </div>
          <div class="weui-cells">
            <employee-field
              ref="emf"
              label="姓名"
              v-model="item.rcd_emname"
              @select="onSelectEmployee($event, item)"
            />
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">工号</label>
              </div>
              <div class="weui-cell__bd">{{item.rcd_emcode}}</div>
            </div>
            <a
              href="javascript:"
              v-if="form.items && xindex==form.items.length-1"
              class="weui-cell weui-cell_link"
              @click="addItem"
            >
              <div class="weui-cell__bd">添加更多</div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="$router.back()">取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import DatetimeField from "@/components/field/DatetimeField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DepartmentField,
    DatetimeField,
    EmployeeField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/hr/repairClass",
      codeField: "rc_code",
      statusField: "rc_statuscode",
      caller: "HrRepairClass",
      xtype: 'hr-repairclass-formpanel',
      form: {
        main: {
          rc_type: "个人",
          rc_department: '',
          rc_departmentid: null,
          rc_depcode: null,
          rc_apply_start: '',
          rc_apply_end: '',
          rc_work_start: '',
          rc_work_end: '',
          rc_apply_count: 0,
          rc_work_count: 0,
          rc_remark: ''
        },
        items: [

        ]
      }
    };
  },
  computed: {
    rc_apply_start() {
      return this.form.main.rc_apply_start;
    },
    rc_apply_end() {
      return this.form.main.rc_apply_end;
    },
    rc_work_start() {
      return this.form.main.rc_work_start;
    },
    rc_work_end() {
      return this.form.main.rc_work_end;
    }
  },
  watch: {
    rc_apply_start: function () {
      this.countHourDiff_apply()
    },
    rc_apply_end: function () {
      this.countHourDiff_apply()
    },
    rc_work_start: function () {
      this.countHourDiff_work()
    },
    rc_work_end: function () {
      this.countHourDiff_work()
    }
  },
  methods: {
    onRctypeChange(e) {
      this.form.main.rc_department = ''
      this.form.main.rc_departmentid = null
      this.form.main.rc_depcode = ''

      if(e.target.value == '个人') {
        this.form.items = []
      } else {
        this.form.items = [
          {
            rcd_detno: 1,
            rcd_emcode: "",
            rcd_emid: null,
            rcd_emname: "",
            id: 0
          }
        ]
      }
    },
    onSelectDepartment(selection) {
      var me = this,
        main = me.form.main;
      main.rc_departmentid = selection.id;
      main.rc_depcode = selection.dp_code

      me.$refs.emf.forEach((item) => {
        item.defaultCondition.push({
          field: "em_dpid",
          operation: "=",
          value: selection.id
        })
      })
      me.initEm(selection.id)
    },
    onSelectEmployee(selection, item) {
      item.rcd_emcode = selection.em_code,
      item.rcd_emid = selection.id,
      item.rcd_emname = selection.em_name
    },
    initEm(id) {
      let me = this
      me.$loading({
        url: '/api/document/employee/list',
        params: {
          condition: JSON.stringify([
            {
              type: "condition",
              value: `em_dpid=${id} and em_class='正式'`
            }
          ])
        }
      }).then(function (res) {
        if(!res.success) {
          me.$weui.topTips(res.message || '获取部门人员错误', 2000);
        } else if (res.data.list.length == 0) {
          me.$weui.topTips("该部门无人员，请重新选择", 2000);

          me.form.main.rc_department = ''
          me.form.main.rc_departmentid = null
          me.form.main.rc_depcode = ''

          me.form.items = [
            {
              rcd_detno: 1,
              rcd_emcode: "",
              rcd_emid: null,
              rcd_emname: "",
              id: 0
            }
          ]
        } else {
          let result = res.data.list.map((item, index) => {
            return {
              id: 0,
              rcd_detno: index + 1,
              rcd_emcode: item.em_code,
              rcd_emid: item.id,
              rcd_emname: item.em_name
            }
          })
          
          me.form.items = result
        }
      });
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.rc_apply_start || !main.rc_apply_end || !main.rc_work_start || !main.rc_work_end) {
        me.$weui.topTips("请完成选择时间", 2000);
      } else if (main.rc_type == '组织' && !main.rc_depcode) {
        me.$weui.topTips("请选择部门", 2000);
      } else if (!main.rc_remark) {
        me.$weui.topTips("请填写补班事由", 2000);
      } else {
        me.p_save()
      }
    },
    countHourDiff_apply() {
      var {rc_apply_start, rc_apply_end} = this.form.main

      if (!rc_apply_start || !rc_apply_end) return

      rc_apply_start = rc_apply_start.replace(' ', 'T')
      rc_apply_end = rc_apply_end.replace(' ', 'T')

      var s_time = new Date(rc_apply_start).getTime(),
        e_time = new Date(rc_apply_end).getTime(),
        rc_apply_count = e_time - s_time;

      if(rc_apply_count < 0) {
        this.$weui.topTips("结束时间需要大于开始时间", 2000);
        return
      }

      rc_apply_count = rc_apply_count/1000/60/60
      // let temp_rc_apply_count = rc_apply_count * 100 + ''
      // let a = temp_rc_apply_count.at(-2)
      // if(a == 7 || a == 2) rc_apply_count -= 0.25

      this.form.main.rc_apply_count = rc_apply_count
    },
    countHourDiff_work() {
      var {rc_work_start, rc_work_end} = this.form.main;

      if (!rc_work_start || !rc_work_end) return

      rc_work_start = rc_work_start.replace(' ', 'T')
      rc_work_end = rc_work_end.replace(' ', 'T')

      var s_time = new Date(rc_work_start).getTime(),
        e_time = new Date(rc_work_end).getTime(),
        rc_work_count = e_time - s_time;

      if(rc_work_count < 0) {
        this.$weui.topTips("结束时间需要大于开始时间", 2000);
        return
      }

      rc_work_count = rc_work_count/1000/60/60
      // let temp_rc_work_count = rc_work_count * 100 + ''
      // let a = temp_rc_work_count.at(-2)
      // if(a == 7 || a == 2) rc_work_count -= 0.25

      this.form.main.rc_work_count = rc_work_count
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      index == 0 ? me.$weui.topTips("请至少保留一行", 2000) : items.splice(index, 1)
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        rcd_detno: items.length,
        rcd_emcode: "",
        rcd_emid: null,
        rcd_emname: "",
        id: 0
      });
    },
  }
};
</script>

<style scoped>
.flex {
  display: flex;
}
</style>